<template>
  <div class="products products-list" v-if="products.length">
    <product-item
      v-for="(product, index) in products"
      :key="product.slug"
      :product="product"
      :index="index"
    />
  </div>
  <div v-else class="emptylist">
    <span>{{ $t('emptyCategory') }}</span>
  </div>
</template>

<script>
import ProductItem from '@/components/product/ProductItem'

export default {
  name: 'ProductsList',
  components: { ProductItem },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
  },
}
</script>

<style></style>
